import { FileCache } from "@pdfking/storage"
import type { AsyncSequence, Bytes } from "@pdfking/tfunc"
import {
  BlobToUint8,
  CopyIterable,
  GuidToString,
  MapAsync,
  ReduceAsync,
  SafeIterable,
  UInt8Hash,
  UnixTime,
} from "@pdfking/tfunc"

import { AutoThrow } from "../errors/AutoThrow"
import type { PdfEngine } from "../types/engine/PdfEngine"
import type { GeneratedFile } from "../types/files/cached/GeneratedFile"
import type { ContentType } from "../types/files/ContentType"
import { VirtualFileType } from "../types/files/VirtualFileType"

export async function GenerateFile(
  engine: PdfEngine,
  stream: AsyncSequence<Blob>,
  content_type: ContentType,
  file_meta?: Record<string, string>
): Promise<GeneratedFile> {
  // file is generated, using uuid
  //

  const { error, stream: copy } = SafeIterable(stream)

  const [chunks, body_size, body_hash] = CopyIterable(copy, 3)

  const [guid, size] = await Promise.all([
    UInt8Hash(MapAsync(BlobToUint8, body_hash)),
    ReduceAsync(
      (acc: Bytes, blob: Blob) => acc + blob.size,
      body_size,
      0
    ) as Promise<Bytes>,
  ])

  await AutoThrow(error)

  const guid_string = GuidToString(guid)
  const modified = UnixTime()

  // Store in cache using the hash as part of the key
  await FileCache(engine.config.file_cache).set(guid_string, {
    chunks,
    size,
    modified,
  })

  return {
    enum: VirtualFileType.GENERATED_FILE,
    type: content_type,
    guid: guid_string,
    size,
    modified,
    file_meta: file_meta ?? {},
  }
}
